import { useEffect } from "react";
import { useLocation } from "react-router";

export default function ScrollToTop({ containerRef }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const el = containerRef?.current;
    if (el) {
      el.scrollTop = 0;
    }
  }, [pathname, containerRef]);

  return null;
}
